var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m21.026,8.885l-5.533-.804-2.475-5.014c-.416-.844-1.62-.844-2.037,0l-2.474,5.014-5.533.804c-.932.136-1.304,1.28-.63,1.937l4.004,3.903-.945,5.511c-.159.928.815,1.635,1.648,1.197l4.949-2.602,4.949,2.602c.833.438,1.807-.269,1.647-1.197l-.945-5.511,4.004-3.903c.674-.657.302-1.802-.63-1.937Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.fb2a1f7b5f898d6ae3b48819a0b4e79d.svg";
export { ForwardRef as ReactComponent };